import { Row, Col, Modal } from "antd";
import { ClockCircleOutlined, BellOutlined } from "@ant-design/icons";
import "./style.css";
import CustomModal from "../../components/modals/CustomModal";
import { useEffect, useState } from "react";
import CustomCard from "../../../dentail-indetifcation/components/d-reusable/CustomCard";
import CustomLinkButton from "../../../dentail-indetifcation/components/d-reusable/CustomLinkButton";
import { getAgeAssessmentTutorials } from "../../../components/https/age-assessment-apis";
import { errorRequestHandel } from "../../../helper";
import CustomSpinner from "../../../dentail-indetifcation/components/d-reusable/CustomSpiner";

const TutorialCard = ({ title, description, onClick }) => {
  return (
    <div className="tutorials-card">
      <h3 className="tutorials-card-title">{title}</h3>
      <p className="tutorials-card-description">{description}</p>
      <div className="tutorials-card-footer">
        {/* <div className="tutorials-read-time">
          <ClockCircleOutlined />
          <span>5 mins Read</span>
        </div> */}
        <CustomLinkButton title={"Read More"} onClick={onClick} />
      </div>
    </div>
  );
};

const Tutorials = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [tutorialDetails, setTutorialDetails] = useState("");

  useEffect(() => {
    getTutorials();
  }, []);

  const getTutorials = async () => {
    try {
      setLoading(true);
      const response = await getAgeAssessmentTutorials();
      if (response.status === 200) {
        setData(response.data.data);
        setLoading(false);
      }
    } catch (error) {
      errorRequestHandel({ error: error });
      setLoading(false);
    }
  };

  const handleClickOnReadMore = (tutorial) => {
    setTutorialDetails(tutorial);
    setIsOpen(true);
  };
  const formatDescription = (text) => {
    if (!text) return "No description available";

    return text
      .replace(/\r\n\r\n/g, "</p><p>") // Convert double newlines to paragraph breaks
      .replace(/\r\n/g, "<br />") // Convert single newlines to line breaks
      .replace(/(\d+\.)/g, '<strong style="color: black;">$1</strong>'); // Bold and black numbering
  };
  return (
    <CustomCard>
      <CustomSpinner loading={loading} />
      <div className="tutorials-container">
        <div className="tutorials-content">
          <h2 className="tutorials-subtitle">Explore How to Examine</h2>

          <Row gutter={[16, 16]}>
            {Array.isArray(data?.["Exam type"]) &&
              data["Exam type"].map((method, index) => (
                <Col md={8} key={index}>
                  <TutorialCard
                    title={method?.title || "No Title"}
                    description={method?.description || "No Description"}
                    onClick={() => handleClickOnReadMore(method)}
                  />
                </Col>
              ))}
          </Row>
        </div>
        <CustomModal
          open={isOpen}
          onCancel={() => setIsOpen(false)}
          width={700}
        >
          <h4>{tutorialDetails?.title}</h4>
          <div className="tutorial_image_section">
            <img
              src={
                tutorialDetails?.link
                  ? tutorialDetails?.link
                  : "https://t3.ftcdn.net/jpg/02/48/42/64/360_F_248426448_NVKLywWqArG2ADUxDq6QprtIzsF82dMF.jpg"
              }
              alt={tutorialDetails?.title}
            />
          </div>
          <div
            dangerouslySetInnerHTML={{
              __html: formatDescription(tutorialDetails?.description),
            }}
            style={{ padding: 10, fontSize: 16, fontFamily: "Poppins-Regular" }}
          />
        </CustomModal>
      </div>
    </CustomCard>
  );
};

export default Tutorials;
